import React from "react";

import TruncatedWithTooltip from "../../../components/TruncatedWithTooltip";

export const applicantsTextColumn = (column) => ({
  align: "left",
  headerAlign: "left",
  ...column,
});

export const renderApplicantsTruncatedCell = (value) => {
  const text = value == null || value === "" ? "-" : String(value);

  return (
    <div className="applicants-page-container__cell-truncate">
      <TruncatedWithTooltip title={text}>
        <span className="MuiDataGrid-cellContent applicants-page-container__truncated-text">
          {text}
        </span>
      </TruncatedWithTooltip>
    </div>
  );
};
